<template>
  <div>
    <div class="IntentionProduct">
      <div class="basic-information-title">意向产品</div>
      <img
        :src="require('@/assets/img/newlyAdd.png')"
        class="newlyAddImg"
        alt
        @click="redact(1)"
        srcset
        v-if="showCC==true && hasLeadCreatedAuth"
      >
    </div>
    <div class="product-list"  v-if="list.length>0">
      <div v-for="(item,index) in list" v-bind:key="index">
        <div class="flex product-list-header">
          <div class="flex center">
            <img class="camera" :src="require('@/assets/img/camera.png')" alt>
            <div class="product-name">体验机型-{{item.trialModel||''}}</div>
          </div>
          <img
            :src="require('@/assets/img/redact.png')"
            class="redactImg"
            alt
            @click="redact(2,item.U_AccLeadId)"
            srcset
            v-if="salesId==item.salesId && showCC==true && hasLeadModifiedAuth"
          >
        </div>
        <div class="product-list-content">
          <!--v-bind:class="item.edit==true?'activeno':'active'"  -->
          <div class="basic-information-flex"  ref="res"  v-bind:class="item.edit==true?'active':'activeno'" >
            <ul class="basic-information-lists">
              <li>
                <div class="basic-information-lists-item">门店</div>
                <div class="basic-information-lists-text">{{item.deptName||''}}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">日期</div>
                <div class="basic-information-lists-text">{{item.addDate?item.addDate.split(" ")[0]:""}}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">意向产品名称</div>
                <div class="basic-information-lists-text" style="max-width: 70%;overflow: auto;word-break: break-all;">{{item.productName||''}}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">购买意向</div>
                <div class="basic-information-lists-text">{{item.intention||''}}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">预计购买日期</div>
                <div class="basic-information-lists-text">{{item.planDate||''}}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">感兴趣课程</div>
                <div class="basic-information-lists-text">{{item.classes||''}}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">感兴趣活动</div>
                <div class="basic-information-lists-text">{{item.campaignTypes||''}}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">了解品牌渠道</div>
                <div class="basic-information-lists-text">{{item.channel||''}}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">购买用途</div>
                <div class="basic-information-lists-text">{{item.purpose||''}}</div>
              </li>
              <li>
                <div class="basic-information-lists-item">销售顾问</div>
                <div class="basic-information-lists-text">{{item.salesName||''}}</div>
              </li>
            </ul>
          </div>
        </div>

        <!-- 收起 -->
        <div class="flex packUp center" @click="packUp(index)">
          <img
            :src="require('@/assets/img/upArrow1.png')"
            v-if="item.edit==true"
            class="arrow"
            alt
            srcset
          >
          <img
            :src="require('@/assets/img/dowmArrow.png')"
            v-if="item.edit==false"
            class="arrow"
            alt
            srcset
          >
          {{item.edit==true?"收起详情":"展开详情"}}
        </div>
      </div>
    </div>
    <!-- 弹框 -->
    <div class="product-model">
      <van-popup 
      v-model="productShow"
      :overlay="true"
      :close-on-click-overlay="false"
      >
        <div>
          <div class="product-title">{{nameTitle}}</div>

          <div class="basic-models-list">
            <div class="basic-models-list-item">
              <div class="models-list-item-title">体验机型</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div class="selectUp" @click="downSelections(0)">
                {{pullList[0]['name']||'请选择'}}
                <img
                  :src="require('@/assets/img/uparrow.png')"
                  class="uparrow"
                  alt
                  srcset
                >
              </div>
            </div>

            <div class="basic-models-list-item soursName">
              <div class="models-list-item-title">意向产品名称</div>
              <input v-model="obj.productName"  maxlength="100" placeholder="请输入意向产品名称"/>
            </div>

            <div class="basic-models-list-item">
              <div class="models-list-item-title">购买用途</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div class="selectUp" @click="downSelections(1)">
                {{pullList[1]['name']||'请选择'}}
                <img
                  :src="require('@/assets/img/uparrow.png')"
                  class="uparrow"
                  alt
                  srcset
                >
              </div>
            </div>

            <div class="basic-models-list-item">
              <div class="models-list-item-title">预计购买日期</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div class="selectUp" @click="downSelections(2)">
                {{pullList[2]['name']||'请选择'}}
                <img
                  :src="require('@/assets/img/uparrow.png')"
                  class="uparrow"
                  alt
                  srcset
                >
              </div>
            </div>

            <div class="basic-models-list-item">
              <div class="models-list-item-title">感兴趣课程</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div class="selectUp" @click="downSelections(3)">
                {{pullList[3]['name']||'请选择'}}
                <img
                  :src="require('@/assets/img/uparrow.png')"
                  class="uparrow"
                  alt
                  srcset
                >
              </div>
            </div>

            <div class="basic-models-list-item">
              <div class="models-list-item-title">感兴趣活动</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div class="selectUp" @click="downSelections(4)">
                {{pullList[4]['name']||'请选择'}}
                <img
                  :src="require('@/assets/img/uparrow.png')"
                  class="uparrow"
                  alt
                  srcset
                >
              </div>
            </div>

            <div class="basic-models-list-item">
              <div class="models-list-item-title">了解品牌渠道</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div class="selectUp" @click="downSelections(5)">
                {{pullList[5]['name']||'请选择'}}
                <img
                  :src="require('@/assets/img/uparrow.png')"
                  class="uparrow"
                  alt
                  srcset
                >
              </div>
            </div>

            <div class="basic-models-list-item">
              <div class="models-list-item-title">购买意向</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div class="selectUp" @click="downSelections(6)">
                {{pullList[6]['name']||'请选择'}}
                <img
                  :src="require('@/assets/img/uparrow.png')"
                  class="uparrow"
                  alt
                  srcset
                >
              </div>
            </div>

            <div class="basic-models-list-item" style="border-bottom:0.01rem solid #eee;">
              <div class="models-list-item-title">门店</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div class="selectUp" @click="downSelections(7)">
                {{pullList[7]['name']||'请选择'}}
                <img
                  :src="require('@/assets/img/uparrow.png')"
                  class="uparrow"
                  alt
                  srcset
                >
              </div>
            </div>

            <div class="basic-models-list-item">
              <div class="models-list-item-title">销售顾问</div>
              <!-- <van-field v-model="name" placeholder="请输入用户名"/> -->
              <div class="selectUp"   @click="pullList[7]['val']?downSelections(8):''">
                {{pullList[8]['name']||'请选择'}}
                <img
                  :src="require('@/assets/img/uparrow.png')"
                  class="uparrow"
                  alt
                  srcset
                >
              </div>
            </div>
          </div>
                                          <!-- 确定取消 -->
            <div class="confirm-cancel">
              <div class="button-flex-color flex-border-button">
                <div class="button-flex-item" @click="cancelProduct">取消</div>
              </div>
              <div class="button-flex-color">
                <div class="button-flex-item button-active" @click="confirmProduct">确定</div>
              </div>
            </div>
        </div>
      </van-popup>
    </div>
     <!-- 时间筛选 -->
    <van-popup v-model="timeShow" position="bottom" :overlay="true" style="width:100%">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        @confirm="timeConfirm"
        @cancel="timeCancel"
        :max-date="maxDate"
        :min-date="minDate"
      />
    </van-popup>

    <!-- 下拉筛选 -->
    <van-popup v-model="showDownSelection" position="bottom" :overlay="true">
      <van-picker
        show-toolbar
        title
        :columns="downSelection"
        @cancel="onCancelCode"  
        @confirm="onConfirmCode"
        :value-key="'name'||'deptName'"
        class="van-picker-li"
      />
    </van-popup>
  </div>
</template>


<script>
  import $ from 'jquery';

export default {
  name: "",
  data() {
    return {
      list: [],
      obj : {},//意向产品对象
      productShow: false, // 编辑 新增 弹框展示
      pullList: [
        { name: "", val: "" }, //体验机型
        { name: "", val: "" }, //购买用途
        { name: "", val: "" }, //预计购买日期
        { name: "", val: "" }, //感兴趣课程
        { name: "", val: "" }, //感兴趣活动
        { name: "", val: "" }, //了解品牌渠道
        { name: "", val: "" }, //购买意向
        { name: "", val:"" }, //门店
        { name: "", val: "" } //销售顾问
      ],
      // 字典表查询code
      codeList: [
        "U_TrialModel",
        "Purpose",
        "Classes",
        "CampaignTypes",
        "Channel",
        "Intention"
      ],
      U_TrialModel: [], //体验机型
      Purpose: [], // 购买用途
      Classes: [], // 感兴趣课程
      CampaignTypes: [], // 感兴趣活动
      Channel: [], // 品牌渠道
      Intention: [], // 购买意向
      Dealer: [], // 门店     经销商列表
      Sales: [] ,// 销售顾问  销售用户
      upSelectCode:0,  // 下拉菜单 选项对应索引
      showDownSelection:false, // 下拉菜单展示
      timeShow:false,  // 下拉时间展示
      currentDate:new Date(this.$D.getFullYear(),this.$D.getMonth(),this.$D.getDate()), // 时间
      minDate: new Date(this.$D.getFullYear(),this.$D.getMonth(),this.$D.getDate()), // 最小时间
      maxDate:new Date(this.$D.getFullYear()+5,this.$D.getMonth(),this.$D.getDate()),
      salesId:this.$wxuserUtil.getUserId(),
      downSelection: ["1", "2"], // 下拉列表
      type:0,  //新增进入0  编辑进入1
      accLeadId:"",  // 意向主键ID, 做修改操作的时候必填. 为空的话,认为是新增操作
      custId:"",//客户ID
      showCC:true,           
      nameTitle:"新增意向产品",
      hasLeadCreatedAuth : true, //是否有意向产品新增权限
      hasLeadModifiedAuth : true //是否有意向产品修改权限
    };
  },
  methods: {
    cancelProduct(){
        this.productShow=false;
        let $PL=[];$PL=this.pullList;
        for(let i=0;i<$PL.length;i++){
             $PL[i]['name']="";
             $PL[i]['val']="";             
        }
        this.pullList=$PL;
    },
    confirmProduct(){
            let $data=this.pullList;
            if($data[0]['val']==''){
              this.$title("请选择体验机型");
              return;
            }
            if($data[1]['val']==''){
              this.$title("请选择购买用途");
              return;
            }
            // if($data[2]['val']==''){
            //   this.$title("请选择购买日期");
            //   return;
            // }

            if($data[5]['val']==''){
              this.$title("请选择渠道");
              return;
            }
            if($data[6]['val']==''){
              this.$title("请选择购买意向");
              return;
            }
            if($data[7]['val']==''){
              this.$title("请选择购买门店");
              return;
            }
            if($data[8]['val']==''){
              this.$title("请选择销售顾问");
              return;
            }
            let data=$.extend(true,{},this.obj,{
              salesId:this.$wxuserUtil.getUserId(),
              custId:this.$parent.$parent.custId,
            });


            data['accLeadId']=this.type==0?'':this.accLeadId;
            data['trialModel']=$data[0]['val'];
            data['purpose']=$data[1]['val'];
            data['planDate']=$data[2]['val'];
            data['classes']=$data[3]['val'];
            data['campaignTypes']=$data[4]['val'];
            data['channel']=$data[5]['val'];
            data['intention']=$data[6]['val'];
            data['userId']=$data[8]['val'];
            this.$loading();

            this.$api.custSaveIntentionProd(data).then(Response=>{
                 if(Response.success==true){
                   if(this.type==0){
                    this.$clear("新增成功");                           
                   }else{
                    this.$clear("修改成功");                        
                   }
                  this.custListIntentionProd(this.custId||this.$parent.$parent.custId);
                  
                  this.$parent.$parent.getCustDetail(this.custId||this.$parent.$parent.custId)
                  this.productShow = false;
                  this.cancelProduct();
                 }else{
                   if(this.type==0){
                           this.$title("新增失败");
                   }else{
                           this.$title(Response.msg || "修改失败");
                   }                   
                 }  
            })
    },
    /**
     * 
     *   时间选择
     * 
     */
    timeConfirm(val){
        this.setUpSelectCode(2,this.upSelectCode,this.$time(val))
    },   
    timeCancel(){
       this.timeShow=false;  
    },
    /**
     * 
     *   下拉菜单选择
     * 
     */
    onConfirmCode(val){
      if(this.upSelectCode>=0&&this.upSelectCode!=2){
         this.setUpSelectCode(1,this.upSelectCode,val)
         this.showDownSelection=false;
      }
    },   
    onCancelCode(){
      this.showDownSelection=false;
    },
    /**
     *
     *   编辑
     *   @param {Number}    1 新增  2  弹框
     */
    redact(val,ID) {
      if (val == 1) {
          this.type=0;
          this.accLeadId='';
          this.toEmpty();
          this.pullList[7]['name']=this.$wxuserUtil.getDeptName();
          this.pullList[7]['val']=this.$wxuserUtil.getDeptId();
          this.pullList[8]['name']=this.$wxuserUtil.getUserName();
          this.pullList[8]['val']=this.$wxuserUtil.getUserId();
          this.getSaleslist(this.$wxuserUtil.getDeptId())
          this.nameTitle="新增意向产品";
      }
      if (val == 2) {
        this.type=1;
        this.accLeadId=ID
        this.custDetailIntentionProd(ID)
          this.nameTitle="修改意向产品";        
      }
      this.productShow = true;
    },

    downSelections(val) {
        this.upSelectCode=val;
        if(val!=2){
        switch(val){
        case 0      :  this.downSelection=this.setCodeAlls(this.U_TrialModel) ;  break
        case 1      :  this.downSelection=this.setCodeAlls(this.Purpose); break 
        case 3      :  this.downSelection=this.setCodeAlls(this.Classes); break    
        case 4      :  this.downSelection=this.setCodeAlls(this.CampaignTypes); break
        case 5      :  this.downSelection=this.setCodeAlls(this.Channel);  break
        case 6      :  this.downSelection=this.setCodeAlls(this.Intention); break 
        case 7      :  this.downSelection=this.setCodeAlls(this.changeList(this.Dealer,1)); break    
        case 8      :  this.downSelection=this.Sales; break
      }
            this.showDownSelection = true;
      }else{
            this.timeShow = true;   
      } 
    },
    changeList(DATA,ID){
        if(Array.isArray(DATA)){
            for(let i=0;i<DATA.length;i++){
                if(ID==1){
                  DATA[i]['name']=DATA[i]['deptName']
                  DATA[i]['value']=DATA[i]['deptId']
                }else{
                  DATA[i]['name']=DATA[i]['userName']
                  DATA[i]['value']=DATA[i]['userId']
                }
            }
            return DATA;
        }
    },
    /**
     *
     *  收起 打开
     *  @param {Bealoon}  val
     *  @param {Number}   index
     */
    packUp(index) {
      let $list = [];
      $list = this.list;
      if ($list[index]["edit"] == true) {
        $list[index]['edit']=false
        this.list=$list;
      }else
      if ($list[index]["edit"] == false) {
         $list[index]['edit']=true
        this.list=$list;
      }
    },
    /**
     * 
     *  弹框确定事件  渲染处理
     *  @param {Number}  ID
     *  @param {Number}  index
     *  @param {Object}  value
     * 
     */
    setUpSelectCode(ID,index,value){
       if(ID==1){
           this.pullList[index]['name']=value.name;
           this.pullList[index]['val']=value.value;
           this.showDownSelection = false;
           if(index==7){
              this.getSaleslist(value.value)
           }
       }
      if(ID==2){
           this.pullList[index]['name']=value;
           this.pullList[index]['val']=value;
           this.timeShow = false;
      }
      if(ID==3){
           this.cameraList[index]['name']=value.name;
           this.cameraList[index]['val']=value.value;
           this.showDownSelection = false;
      }      
    },
    /**
     *
     * 字典查询
     *
     */
    getQueryByTcode() {
      for (let i = 0; i < this.codeList.length; i++) {
        this.$api.getQueryByTcode({ tcode: this.codeList[i] })
          .then(Response => {
            switch (this.codeList[i]) {
              case "U_TrialModel"   :  this.U_TrialModel = Response.data;break;
              case "Purpose"        :  this.Purpose = Response.data;break;
              case "Classes"        :  this.Classes = Response.data;break;
              case "CampaignTypes"  :  this.CampaignTypes = Response.data;break;
              case "Channel"        :  this.Channel = Response.data;break;
              case "Intention"      :  this.Intention = Response.data;break;
            }
          });
      }
    },
    /**
     *
     *  查询经销商
     *
     **/
    getDealerlist() {
      this.$api.getDealerlist({ salesId: this.$wxuserUtil.getUserId() })
        .then(Response => {
          this.Dealer = Response.data;
        });
    },
    /**
     *
     *   销售用户
     *
     **/
    getSaleslist(deptId) {
      this.$api.getSaleslist({salesId: this.$wxuserUtil.getUserId(),deptId:deptId}).then(Response => {
        this.Sales = this.changeList(Response.data,2);
      });
    },
    /**
     * 
     * 
     *   客户意向产品详情
     * 
     * 
     */
    custDetailIntentionProd(ID){
      this.$api.custDetailIntentionProd({
        salesId: this.$wxuserUtil.getUserId(),custId:this.$parent.$parent.custId,accLeadId:ID
      }).then(Response=>{
          if(Response.success==true){
              let $data     =    Response.data;
              this.obj = $data;
              let $pullList=[];
              $pullList=this.pullList;
              $pullList[0]['name']=$data.trialModel||'';
              $pullList[0]['val']=$data.triaModelVal||'';
              $pullList[1]['name']=$data.purpose||'';
              $pullList[1]['val']=$data.purposeVal||'';
              $pullList[2]['name']=$data.planDate.split(" ")[0]||'';
              $pullList[2]['val']=$data.planDate.split(" ")[0]||'';
              $pullList[3]['name']=$data.classes||'';
              $pullList[3]['val']=$data.classesVal||'';
              $pullList[4]['name']=$data.campaignTypes||'';
              $pullList[4]['val']=$data.campaignTypesVal||'';       
              $pullList[5]['name']=$data.channel||'';
              $pullList[5]['val']=$data.channelVal||'';       
              $pullList[6]['name']=$data.intention||'';
              $pullList[6]['val']=$data.intentionVal||'';  
              $pullList[7]['name']=$data.deptName||'';
              $pullList[7]['val']=$data.deptId||'';                      
              $pullList[8]['name']=$data.salesName||'';
              $pullList[8]['val']=$data.salesId||'';  
              this.pullList=$pullList;
          }

      })
    },
    /**
     * 
     * 
     *   客户意向产品列表
     * 
     * 
     */
    custListIntentionProd(ID){
      this.custId=ID;
      this.$api.custListIntentionProd({salesId: this.$wxuserUtil.getUserId(),custId:ID})
      .then(Response=>{
            console.log("更新*****",Response)
           if(Response.success==true){
             if(Response.data.length>0){
               for(let i=0;i<Response.data.length;i++){
                 Response.data[i]['edit']=false;
                 Response.data[i]['height']='auto';
               }
             this.list=Response.data;
             }
           }
      })
    },
//清空全部
  toEmpty(){
    for(let i=0;i<this.pullList.length;i++){
       this.pullList[i]['name']='';
       this.pullList[i]['value']='';
       this.pullList[i]['val']='';
    }
    this.obj.productName="";
  }, 
  /**
    * 
    *   添加全部
    * 
    */
   setCodeAlls(data){
      if(Array.isArray(data)){
        return  [{name:"请选择",value:"",val:""}].concat(data);  
      }else{
        return  [].concat(data);
      }
   },
   authority(Bl){
   this.showCC=Bl;
   },    
  },
  mounted() {
    this.hasLeadCreatedAuth = this.$wxuserUtil.hasFunAuthByRouteInst(this.$route,this.$funcKey.LeadCreated);
    this.hasLeadModifiedAuth = this.$wxuserUtil.hasFunAuthByRouteInst(this.$route,this.$funcKey.LeadModified);
    this.getQueryByTcode();
    this.getDealerlist();
  },
  created() {}
};
</script>



<style lang="less" scoped>
.product-model {
  .van-popup {
    width: 9rem;
    height: 15.0rem;
    border-radius: 0.3rem;

    // 确定取消
    .confirm-cancel {
      width: 100%;
      height: 1.4rem;
      // border-top: 1px solid #b3b8c3;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      position: fixed;
      bottom: 0rem;
      width:100%;
      .button-flex-color {
        width: 50%;
        height: 1.4rem;
        text-align: center;
        .button-flex-item {
          width: 100%;
          height: 100%;
          text-align: center;
          line-height: 1.3rem;
          font-size: 0.4rem;
          background: #222222;
          color: #fff;
        }
        .button-active {
          background: #e51c23;
          color: #fff;
        }
      }
      .flex-border-button {
        // border-right: 1px solid #a4abba;
      }
    }

    .product-title {
      height: 1.5rem;
      line-height: 1.5rem;
      text-align: center;
      font-weight: bold;
      color: #252424;
    }
    .basic-models-list {
      height: 95%;
      font-size: 0.35rem;
      // overflow-x: auto;
      width: 95%;
      margin: 0 auto;
      .basic-models-list-item,
      .basic-models-list-itemS {
        margin-left: 0.8rem;
        height: 1.2rem;
        -ms-flex-item-align: center;
        align-items: center;
        display: flex;
        flex-direction: row;
        // justify-content: space-between;
        position: relative;
      }
      .selectUp {
        border: 0;
        margin: 0;
        padding: 0;
        width: 100%;
        resize: none;
        display: block;
        color: #323233;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        background-color: transparent;
        .uparrow {
          position: absolute;
          right: 0.2rem;
          top: 50%;
          width: 0.3rem;
          height: 0.3rem;
          margin-top: -0.15rem;
        }
        input {
          border: none;
          outline: none;
        }
        textarea {
          border: none;
          outline: none;
          height: 0.8rem;
          width: 4rem;
        }
      }
    }

    .soursName{

      input{
        width:100%;
        border:none;
        outline: none;
        text-align: left;
      }
    }

    .basic-models-list-item:after {
      /*content: "  ";*/
      /*position: absolute;*/
      /*left: 0;*/
      /*bottom: 0;*/
      /*width: 100%;*/
      /*height: 1px;*/
      /*background-color: #b3b8c3;*/
      /*!* 如果不用 background-color, 使用 border-top:1px solid #f00; 效果是一样的*!*/
      /*-webkit-transform: scaleY(0.15);*/
      /*-o-transform: scaleY(0.15);*/
      /*-ms-transform: scaleY(0.15);*/
      /*transform: scaleY(0.15);*/
    }
    .van-cell {
      padding: 0rem;
    }
    .models-list-item-title {
      width: 5rem;
    }
    .region {
      width: 3rem;
      position: relative;
      height: 1.2rem;
      line-height: 1.2rem;
      -ms-flex-item-align: center;
      align-items: center;
      padding-left: 0.1rem;
      // border-right: 1px  solid  #b3b8c3;
      .uparrow {
        position: absolute;
        right: 0.5rem;
        top: 50%;
        width: 0.3rem;
        height: 0.3rem;
        margin-top: -0.15rem;
      }
    }
  }
}
.newlyAddImg {
  width: 0.5rem;
  height: 0.5rem;
}
    .active {
      height: auto!important;
      
    }
    .activeno {
      height: 3.1rem!important;
    }
.product-list-content{
    .basic-information-flex {
    padding: 0.3rem 0.5rem;
    overflow: hidden;
    transition: all 0.5s;
    -webkit-transition: all 0.5s;
    -o-transition: all 0.5s;
    -ms-transition: all 0.5s;
    }
    }
.product-list {
  margin: 0.3rem 0.5rem 0.3rem 0.5rem;
  // background: #F2F2F2;
  min-height: 1rem;
  .basic-information-flex {
    padding: 0.3rem 0.5rem;
    overflow: hidden;
    transition: all 0.5s;
    -webkit-transition: all 0.5s;
    -o-transition: all 0.5s;
    -ms-transition: all 0.5s;
    .basic-information-lists {
      li {
        display: flex;
        //    justify-content: space-between;
        -ms-flex-item-align: center;
        align-items: center;
        min-height: 0.8rem;
        line-height: 0.8rem;
      }
      .basic-information-lists-item {
        width: 2.5rem;
        color: #7e7e7e;
        font-size: 0.35rem;
      }
      .basic-information-lists-text {
        font-size: 0.35rem;
        color: #4d4d4d;
      }
    }
  }
  .product-list-content {
    background: #f2f2f2;
  }
  .packUp {
    padding: 0rem 0.3rem;
    background: #f2f2f2;
    margin-top: 0.05rem;
    margin-bottom: 0.3rem;
    height: 1rem;
    line-height: 1rem;
  }
  .arrow {
    width: 0.4rem;
    height: 0.4rem;
  }
  .product-list-header {
    height: 1rem;
    -ms-flex-item-align: center;
    align-items: center;
    padding: 0rem 0.3rem;
    flex-direction: row;
    justify-content: space-between;
    background: #f2f2f2;
    .product-name {
      color: #2a2a2a;
      font-size: 0.4rem;
      padding-left: 0.3rem;
    }
  }
  .camera,
  .redactImg {
    width: 0.4rem;
    height: 0.4rem;
  }
}
.IntentionProduct {
  // width:100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  -ms-flex-item-align: center;
  align-items: center;
  height: 1rem;
  padding: 0.3rem 0.5rem 0rem 0.5rem;
  border-top: 0.1rem solid rgb(244, 244, 244);
  .redactImg {
    width: 0.4rem;
    height: 0.4rem;
  }
  .basic-information-title {
    position: relative;
    color: #2a2a2a;
    font-size: 0.4rem;
    font-weight: 600;
  }
  .basic-information-title::after {
    content: "";
    width: 0.1rem;
    height: 0.35rem;
    position: absolute;
    left: -0.2rem;
    top: 0.12rem;
    background-color: #e10913;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/client/childCompoents/IntentionProduct.vue